import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';

const TaxModal = ({ show, handleClose,handleSubmit,country,handleData,countryList,errorMessage,province,gst,setotherExpenses,options,otherExpenses,workerData,stateList}) => {

 
    return (

        <div >
            <Modal backdrop="static"
        keyboard={false} show={show} centered onHide={handleClose} className='deleteModal'  >

                <div className="border border-primary border-4">
                    <Modal.Header closeButton className='bg-primary text-white'>
                        <Modal.Title>Tax {workerData.createdAt ? "Edit" : "Add"}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body >

                    <div className="row">
                                    <div className="col-xl-6 col-md-6 mb-2">
                                        <div className="form-group">
                                            <label htmlFor="" className="form-lbl">
                                                Country<span className="must-field">*</span>
                                            </label>
                                            <select
                                                value={country}
                                                name="country"
                                                onChange={(e) => handleData(e)}
                                                className={`form-control`}
                                                placeholder={`Country`}
                                            >
                                                <option value="">Choose Country</option>
                                                {countryList?.map((items, i) => {
                                                    return (
                                                        <option key={i} value={items.id}>
                                                            {items.country_name}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                            {errorMessage?.country ? (
                                                <div
                                                    className="error error-message"
                                                    style={{ color: "red" }}
                                                >
                                                    {errorMessage?.country}
                                                </div>
                                            ) : (
                                                ""
                                            )}

                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-md-6 mb-2">
                                        <div className="form-group">

                                            <label htmlFor="" className="form-lbl">
                                                Province<span className="must-field">*</span>
                                            </label>
                                            <select
                                                value={province}
                                                name="province"
                                                onChange={(e) => handleData(e)}
                                                className={`form-control`}
                                                placeholder={`Province`}
                                            >
                                                {!workerData?.createdAt && <option value="">Please choose a provice</option>}
                                                {stateList?.map((items) => {
                                                    return (
                                                        <option value={items.id} key={items.id}>
                                                            {items.province_name}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                            {errorMessage?.province ? (
                                                <div
                                                    className="error error-message"
                                                    style={{ color: "red" }}
                                                >
                                                    {errorMessage?.province}
                                                </div>
                                            ) : (
                                                ""
                                            )}

                                        </div>
                                    </div>
                                    <div className="row m-0 p-0 mb-3 ">
                                        <div className="col-md-12 col-xl-9 mb-2 ">
                                            <div className="form-group">
                                                <label htmlFor="" className="form-lbl">
                                                    Other Taxes
                                                </label>



                                                <Select
                                                    value={otherExpenses}
                                                    isMulti
                                                    name="colors"
                                                    options={options}
                                                    onChange={(item) => {

                                                        setotherExpenses(item)
                                                    }}
                                                    // className="py-3"
                                                    placeholder="choose other taxes"
                                                    classNamePrefix="select Expenses tax-class"

                                                />



                                            </div>
                                        </div>


                                        <div className="row">
                                            <div className="col-xl-3 col-md-3 ">
                                                <div className="form-group">
                                                    <label htmlFor="" className="form-lbl">
                                                        Gst (%)
                                                    </label>
                                                    <input
                                                        type="text"
                                                        value={gst}
                                                        // readOnly={readOnlyFields?.includes("gst")}

                                                        name="gst"
                                                        onChange={(e) =>{
                                                            e.target.value =    e.target.value.replace(/[^0-9]/g,"")

                                                           
                                                            handleData(e)}}
                                                        className={`form-control `}
                                                        placeholder="Gst "
                                                    />
                                                    {errorMessage?.gst ? (
                                                        <div
                                                            className="error error-message"
                                                            style={{ color: "red" }}
                                                        >
                                                            {errorMessage?.gst}
                                                        </div>
                                                    ) : (
                                                        ""
                                                    )}
                                                </div>

                                            </div>
                                            {
                                                otherExpenses?.map(oei =>
                                                    <>




                                                        <div className="col-xl-3 col-md-3 " key={oei.value}>
                                                            <div className="form-group">
                                                                <label htmlFor="" className="form-lbl">
                                                                    {oei.label} (%)
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    value={workerData?.[oei.label.toLowerCase()]}
                                                                    // readOnly={readOnlyFields?.includes("bts")}
                                                                    name={oei.label.toLowerCase()}

                                                                    onChange={(e) =>{
                                                                        e.target.value =    e.target.value.replace(/[^0-9]/g,"")

                                                                       
                                                                        handleData(e)}}
                                                                    className={`form-control `}
                                                                    placeholder={oei.value}
                                                                />
                                                                {errorMessage?.bts ? (
                                                                    <div
                                                                        className="error error-message"
                                                                        style={{ color: "red" }}
                                                                    >
                                                                        {errorMessage?.bts}
                                                                    </div>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </div>

                                                        </div>
                                                    </>

                                                )
                                            }
                                        </div>


                                    </div>
                                </div>
                                {errorMessage?.global && (
                                                        <div
                                                            className="error error-message"
                                                            style={{ color: "red" }}
                                                        >
                                                            {errorMessage?.global}
                                                        </div>
                                                    ) }

                        <div className="d-flex justify-content-between">

                            <button onClick={handleClose} className='ms-0 btn px-4 close__button'>
                                <p className='mb-0 px-4'>  Cancel</p>
                            </button>
                            <button onClick={handleSubmit} className='px-5 btn-primary'>
                                <p className='mb-0 px-4'>  Ok</p>
                            </button>
                        </div>

                    </Modal.Body>




                </div>

            </Modal>
        </div>

    )
}

export default TaxModal